export default [
  {
    key: 'put_plans_num',
    name: '在投计划数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'plans_and_ideas',
  },
  {
    key: 'put_ideas_num',
    name: '在投创意数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'plans_and_ideas',
  },
  {
    key: 'new_ideas_num',
    name: '新增创意数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'plans_and_ideas',
  },
  {
    key: 'online_resources_num',
    name: '在线素材数',
    sortable: false,
    filterable: false,
    type: 'target',
    parent: 'plans_and_ideas',
  },
  {
    key: 'new_resources_num',
    name: '新增素材数',
    sortable: false,
    filterable: false,
    type: 'target',
    parent: 'plans_and_ideas',
  },
];
